import _ from 'lodash'
import animate from 'animate.css'
import classnames from 'classnames'
import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { CloseCircleFilled } from '@ant-design/icons'

import classList from '~/lib/classList'

import styles from './Modal.css'

const VALID_PANELS = ['right', 'left']
const VALID_PLACEMENTS = ['top', 'bottom']

export class ModalController extends PureComponent {
    static propTypes = {
        isOpen: PropTypes.bool,
        children: PropTypes.node,
    }

    render() {
        return this.props.isOpen ? this.props.children : null
    }
}

export class Modal extends PureComponent {
    static propTypes = {
        isV2: PropTypes.bool,
        clearBackground: PropTypes.bool,
        children: PropTypes.node,
        size: PropTypes.oneOf(['small', 'medium', 'large']),
        panel: PropTypes.oneOf(VALID_PANELS),
        placement: PropTypes.oneOf(VALID_PLACEMENTS),
        onBackgroundClick: PropTypes.func,
    }

    componentDidMount() {
        classList(document.body).add(styles.freeze)
    }

    componentWillUnmount() {
        classList(document.body).remove(styles.freeze)
    }

    onBackgroundClick = () => {
        if (this.props.onBackgroundClick) {
            this.props.onBackgroundClick()
        }
    }

    _modalSizeStyle() {
        const { isV2, size } = this.props

        if (isV2) {
            if (size === 'small') {
                return styles.modalSizeSmallV2
            } else if (size === 'medium') {
                return styles.modalSizeMediumV2
            } else if (size === 'large') {
                return styles.modalSizeLargeV2
            }
        } else if (size === 'medium') {
            return styles.modalSizeMedium
        } else if (size === 'large') {
            return styles.modalSizeLarge
        }

        return styles.modalSizeSmall
    }

    render() {
        const { panel, placement, clearBackground } = this.props
        const isValidPanel =
            _.isString(panel) && VALID_PANELS.some(p => p === panel)
        const isValidPlacement =
            _.isString(placement) && VALID_PLACEMENTS.some(p => p === placement)

        return (
            <div
                className={classnames(
                    styles.screen,
                    clearBackground && styles.clear,
                    isValidPanel && styles.panel,
                    isValidPlacement && styles[`${[placement]}Panel`],
                )}
            >
                <div
                    className={classnames(
                        styles.background,
                        clearBackground && styles.clear,
                    )}
                    onClick={this.onBackgroundClick}
                />
                <div
                    className={classnames(
                        animate.animated,
                        animate.fadeIn,
                        styles.modal,
                        this._modalSizeStyle(),
                        styles.modalOpen,
                        isValidPanel && styles[`${panel}Panel`],
                        isValidPanel && styles.panel,
                    )}
                >
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export class ModalHeader extends PureComponent {
    static get propTypes() {
        return {
            isSimple: PropTypes.bool,
            isV2: PropTypes.bool,
            feature: PropTypes.bool,
            children: PropTypes.node,
            onCloseClick: PropTypes.func,
        }
    }

    render() {
        const { isV2, isSimple, feature, onCloseClick } = this.props

        if (isV2) {
            return (
                <div
                    className={
                        isSimple
                            ? styles.simpleHeaderWrapper
                            : styles.headerWrapper
                    }
                >
                    {typeof onCloseClick === 'function' && (
                        <div
                            onClick={onCloseClick}
                            className={classnames(
                                styles.cancel,
                                isSimple && styles.cancelSimple,
                            )}
                        >
                            cancel
                        </div>
                    )}
                    <div className={!isSimple ? styles.titleV2 : undefined}>
                        {this.props.children}
                    </div>
                </div>
            )
        }

        return (
            <div className={styles.titleWrapper}>
                <div
                    className={styles.closeButton}
                    data-qa="modal-close"
                    onClick={onCloseClick}
                >
                    <CloseCircleFilled />
                </div>
                <div
                    className={classnames(styles.title, {
                        [styles.feature]: feature,
                    })}
                >
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export class ModalBody extends PureComponent {
    static get propTypes() {
        return {
            isV2: PropTypes.bool,
            children: PropTypes.node,
        }
    }

    modalBodyStyle() {
        if (this.props.isV2) {
            return styles.bodyV2
        }
        return styles.body
    }

    render() {
        return (
            <div className={this.modalBodyStyle()}>{this.props.children}</div>
        )
    }
}
